const lockedFieldConfig = {
  disabled: true,
  inputClassName: "!bg-white !text-gray-400 !border-gray-400",
};

const disableForInvoice = ({
  invoice,
  hasPermission,
  permission,
  extraCondition = false,
}) =>
  invoice?.isExported || extraCondition || !hasPermission(permission)
    ? lockedFieldConfig
    : {};

export { disableForInvoice, lockedFieldConfig };
